import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModoAplicacionEnum } from 'config/instrumentos';

const initialState = { modoAplicacion: ModoAplicacionEnum.autoevaluacion, isExternal: false };

const selectedCurrentViewInstrumentoSlice = createSlice({
	name: 'selectedCurrentViewInstrumento',
	initialState,
	reducers: {
		setCurrentViewInstrumento: (
			state,
			action: PayloadAction<{ modoAplicacion: ModoAplicacionEnum; isExternal: boolean }>
		) => {
			return action.payload;
		}
	}
});

export const { setCurrentViewInstrumento } = selectedCurrentViewInstrumentoSlice.actions;

export default selectedCurrentViewInstrumentoSlice.reducer;
